import React from "react";
import { useEffect } from "react";

import ReactDOM from "react-dom";
import { BrowserRouter as Router, useLocation } from "react-router-dom";

import * as Sentry from "@sentry/browser";
import "array-flat-polyfill";

import { isTouch } from "./core/utils";
import "./styles/custom-properties.scss";
import "./styles/resets.scss";
import App from "./tpo/App";

const release = import.meta.env.VITE_VERSION || "0.0.0";

console.log(`Regenerus : v${release}`);
console.log(`VITE_ENV is ${import.meta.env.VITE_ENV || "local"}`);
console.log(`NODE_ENV is production: ${import.meta.env.PROD}`);

if (import.meta.env.VITE_ENV === "production") {
  // TODO do we get anything extra from doing this?
  // https://medium.com/@vshab/create-react-app-and-sentry-cde1f15cbaa
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      release: release,
      environment: import.meta.env.VITE_ENV,
      ignoreErrors: [
        // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/23
        "Object Not Found Matching Id",
        "undefined is not an object (evaluating 'document.getElementsByTagName('video')[0].webkitExitFullScreen')"
      ],
      ignoreUrls: [
        "https://js.hscollectedforms.net/collectedforms.js",
        "https://www.googletagmanager.com/gtag/js?id=G-SXBCE6MPG9"
      ]
    });
  }
}

if (import.meta.env.VITE_ENV === "production") {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", "UA-156447102-1");
}

if (isTouch()) {
  document.body.setAttribute("data-touch", true);
}

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
